import { render, staticRenderFns } from "./PatientProfileContent.vue?vue&type=template&id=4ad08ca6&"
import script from "./PatientProfileContent.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PatientProfileContent.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ad08ca6')) {
      api.createRecord('4ad08ca6', component.options)
    } else {
      api.reload('4ad08ca6', component.options)
    }
    module.hot.accept("./PatientProfileContent.vue?vue&type=template&id=4ad08ca6&", function () {
      api.rerender('4ad08ca6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/components/PatientProfile/PatientProfileContent.vue"
export default component.exports